const { default: axios } = require("axios");

window.locale = 'lt';
$(function(){
    window.locale = $('html').attr('lang');

    window.initAllOnObject($('body'));
    
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = $('meta[name="csrf-token"]').attr('content');

    $('#registerModal').on('hidden.bs.modal', function() {
        $('#register_form').find('.legal_person_fields').hide();
        $(':input','#register_form').val('').prop('checked', false);
        $('#register_form').find('.error-text').hide();
    });

    $('#loginModal').on('hidden.bs.modal', function() {
        $(':input','#login_form').val('');
        $('#login_form').find('.error-text').removeClass('d-block');
    });
});

window.initSelect2 = function(items=false){
    if(items === false)
    items = $('.select2');
    

    items.each(function(index, element){
        let settings = {
            'width': '100%',
        };

        if ($(element).data('attributes') !== undefined) {
            let attributes =  $(element).data('attributes');
           
            for (let key in attributes) {
                if (attributes.hasOwnProperty(key)) {         
                    settings[key] = attributes[key];      
                }          
            };
        }
        
        if($(this).parents('.modal').length > 0)
            settings['dropdownParent'] = $(this).parents('.modal').eq(0);

        $(element).select2(settings);
    });
}
window.initSelect2Tags = function(items=false){
    if(items === false)
        items = $('.select2_tags');

    items.each(function(index, element) {
        let settings = {
            'tags': true,
            'width' : '100%',
        };

        if ($(element).data('attributes') !== undefined) {
            let attributes =  $(element).data('attributes');
           
            for (let key in attributes) {
                if (attributes.hasOwnProperty(key)) {         
                    settings[key] = attributes[key];      
                }          
            };
        }

        if($(this).parents('.modal').length > 0)
            settings['dropdownParent'] = $(this).parents('.modal').eq(0);
            
        $(element).select2(settings);
    });
}
window.initSelect2Ajax = function(items=false){
    if(items === false)
        items = $('.select2_ajax');
            
    items.each(function(index, element){
        let settings = {
            'ajax': {
                'url': $(element).data('url'),
                'data': function(params){
                    let query = {};
                    if($(element).data('additional') != undefined){
                        query = JSON.parse($(element).data('additional'));
                    }

                    query['term'] = params.term; 
                    query['page'] = params.page || 1;

                    return query;
                }
            },
            'width': '100%',
        };
        if($(this).parents('.modal').length > 0)
            settings['dropdownParent'] = $(this).parents('.modal').eq(0);
        
        $(element).select2(settings);
    });
}
window.initDateRangePicker = function(items=false){
    if(items === false){
        items = $('.date-range-picker');
    }

    let completeLocale = window.daterangepickerLocales[window.locale];
    completeLocale['format'] = 'YYYY-MM-DD';
 
    items.each(function(index, element){
        let settings = {
            'autoApply': true,
            'locale': completeLocale
        };

        if($(this).parents('.modal').length > 0){
            settings['parentEl'] = '#'+$(this).parents('.modal').attr('id');
        }

        let customSettings = $(element).data('custom-datepicker-settings');
        if(customSettings){
            $.each(customSettings, function(settingKey, settingOption){
                if(settingKey === 'noWeekends' && !empty(settingOption)){
                    settings['isInvalidDate'] = function(date){
                        return moment(date).isoWeekday() >= 6;
                    };
                    return true;
                }
                settings[settingKey] = settingOption;
            });
        }

        $(element).daterangepicker(settings);
    });


    items.attr('autocomplete', 'off');
}
window.initDatePicker = function(items=false){
    if(items === false){
        items = $('.datepicker');
    }

    let completeLocale = window.daterangepickerLocales[window.locale];
    completeLocale['format'] = 'YYYY-MM-DD';
 
    items.each(function(index, element){
        let settings = {
            'minDate': new Date(),
            'singleDatePicker': true,
            'autoApply': true,
            'locale': completeLocale
        };

        let customSettings = $(element).data('custom-datepicker-settings');

        if(customSettings){
            $.each(customSettings, function(settingKey, settingOption){
                if(settingKey === 'noWeekends' && !empty(settingOption)){
                    settings['isInvalidDate'] = function(date){
                        return moment(date).isoWeekday() >= 6;
                    };
                    return true;
                } else if (settingKey === 'holidays') {
                    let disabledDates = settingOption.map(function(dateString) {
                        return moment(dateString);
                    });              
                         
                    settings['isInvalidDate'] = function(date){
                        let holiday = disabledDates.some(function(disabledDate) {
                            return disabledDate.isSame(date, 'day');
                        });       
                    
                        return holiday || moment(date).isoWeekday() >= 6;
                    };
                    return true;
                }
                settings[settingKey] = settingOption;
            });
        }

        $(element).daterangepicker(settings);
    });


    items.attr('autocomplete', 'off');
}
window.initDateTimePicker = function(items=false){
    if(items === false){
        items = $('.date-time-picker');
    }

    let completeLocale = window.daterangepickerLocales[window.locale];
    completeLocale['format'] = 'YYYY-MM-DD HH:mm:ss';

    items.daterangepicker({
        'minDate': new Date(),
        "timePicker": true,
        "timePicker24Hour": true,
        'singleDatePicker': true,
        'autoApply': true,
        'locale': completeLocale
    });

    items.attr('autocomplete', 'off');
}
window.initAllOnObject = function(object){
    object = $(object);

    window.initSelect2(object.find('.select2'));
    window.initSelect2Tags(object.find('.select2_tags'));
    window.initSelect2Ajax(object.find('.select2_ajax'));
    window.initDatePicker(object.find('.datepicker'));
    window.initDateTimePicker(object.find('.date-time-picker'));
    window.initDateRangePicker(object.find('.date-range-picker'));
}

window.trans = function(key){
    return translations[key] || '--';
}
window.showToast = function(text="Tekstas", color="#c91a13", timeout=2000){
    let unique_id = Date.now();

    $('#toast_container').append(`
        <div class="custom-toast toaster_${unique_id}" style="background-color: ${color};">
            <div class="custom-toast-header">
                <strong class="mr-auto">Pranešimas</strong>
                <button type="button" class="close" onclick="$(this).parents().eq(1).remove();">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="custom-toast-body">${text}</div>
        </div>
    `);

    setTimeout(function(){
        $('#toast_container').find(`.toaster_${unique_id}`).remove();
    }, timeout);
}
window.checkPaymentStatus = function(orderNo){
    axios.post(routes.CheckArePaymentIsConfirm, {'order_no': orderNo})
    .then(function(response){      
        if(response.data){
            location.href = `${routes.PaymentConfirmed}?order_number=${encodeURIComponent(orderNo)}`;
        }        
    }).catch(function(errors){              
        console.log(errors);
    });
} 

window.changeDatePickerMaxMinValue = function(picker){
    if (picker.name === 'from') {
        $(picker).parents(1).find('.date-picker[name=to]').datepicker("option", "minDate", $(picker).datepicker('getDate'));
    } else {
        $(picker).parents(1).find('.date-picker[name=from]').datepicker("option", "maxDate", $(picker).datepicker('getDate'));
    }
}

window.openConfirmPopUp = function(){
    $('.confirm-popup').addClass('is-visible');
    $(".confirm-popup").css("z-index", "1500");
}

window.closeConfirmPopUp = function (){
    $('.confirm-popup').removeClass('is-visible');
}

window.confirmPopUpYes = function(){
    closeConfirmPopUp();   
    $('#accountDeactyvationModal').modal('toggle');
}

window.destroyAccount = function(){
    let url = routes.DestroyAccount;
    let email = $('[name="email"]').val();
    let password = $('[name="password"]').val();

    axios.post(url, {
        email: email,
        password: password,
    }, {
        headers: {
            'Content-Type': 'application/json',
        },
    }).then(function(response) {
        window.location.href = '/';
    }).catch(function(error) {           
        console.error(error);    
    });
}

window.confirmPopUpNo = function(){
    closeConfirmPopUp();       
}

window.checkOnBlur = function(input){  
    $(input).removeClass('full');
    if($(input).val() !== ''){
        $(input).addClass('full');
    }
}
window.empty = function(value){
    if(!value || 
        value === '' || 
        value === null || 
        value === undefined || 
        value === 'false' || 
        value === '0' || 
        value === 'null' || 
        value === 'undefined'
    ){
        return true;
    }
    return false;
}
window.getEasterDate = function(year) {
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    month--;

    return new Date(year, month, day);
}